<template>
  <!-- Modal -->
  <div class="modal fade" id="EstimateDetailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-primary d-flex">
            <input class="form-control form-control-sm width-40 mr-2" type="text" v-model="productSearch" :placeholder="translations('common.keyword_search')" @keyup.enter="doSearchProduct">
            <button type="button" @click="doSearchProduct()" class="btn btn-sm btn-primary">{{translations('common.search')}}</button>
          </div>
          <div class="table-scroll">
            <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('estimate.item_number')}}</th>
                  <th>{{translations('estimate.jan_code')}}</th>
                  <th>{{translations('estimate.model')}}</th>
                  <th>{{translations('estimate.quantity')}}</th>
                  <th>{{translations('estimate.unit_price')}}</th>
                  <th>{{translations('estimate.summary')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <tr v-for="(product, i) in products" :key="i">
                    <td>{{ product.item_no }}</td>
                    <td>{{ product.jan_code }}</td>
                    <td>{{ product.type_number }}</td>
                    <td><input v-on:keyup="quantityKeyUp($event,product)" class="form-control min-width-150" v-model="product.quantity" type="text"></td>
                    <td><input class="form-control min-width-150" v-model="product.unit_price" type="text" :placeholder="tempUnitPrices[i]"></td>
                    <td><input class="form-control min-width-150" v-model="product.remarks" type="text"></td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeAddToModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateDetaitls()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
export default {
  name: 'EstimateDetailsModal',
  components: {
    VueElementLoading
  },
  props: {
    tax: {}, // VAT
    details: {},
    clientsId: {}
  },
  data () {
    return {
      productSearch: '',
      products: [],
      tempDetails: [],
      testData: [],
      tempUnitPrices: [],
      isSearching: false
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  watch: {
    details: {
      handler (data, oldData) {
        data.forEach((d, i) => {
          if (oldData[i] !== undefined) {
            d = this.prepareDetails(d, true)
          }
        })
      },
      deep: true
    }
  },
  mounted () {
    window.$('#EstimateDetailsModal').on('shown.bs.modal', function () {
      window.$('#EstimateDetailsModal').find('.table-scroll').css('height', (window.innerHeight - 280) + 'px')
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, tempDetail) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      tempDetail.quantity = value
    },
    async doSearchProduct () {
      this.isSearching = true
      try {
        let products = await this.$http.post(
          this.$api_url.products_keyword_search,
          { keyword: this.productSearch, clients_id: (typeof this.$props.clientsId) !== 'undefined' ? this.$props.clientsId.id : 0 }
        )
        let $data = this.$invoiceTools.prepareResult(products.data, 'list', 'EstimateDetailsModal:doSearchProduct')
        if ($data.success === true) {
          console.log('doSearchProduct: ', ($data.data.length > 0))
          this.products = $data.data
          let $this = this
          this.products.forEach(function (product) {
            $this.tempUnitPrices.push(product.unit_price)
          })
        } else {
          this.$toastr.error(this.translations(`estimate.${$data.data}`), this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewSales:doSearchProduct:catch(error): ', error)
        this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
      } finally {
        this.isSearching = false
      }
    },
    emptyTempDetails () {
      this.tempDetails = {
        product_id: '',
        jan_code: '',
        type_number: '',
        taxclass_id: '1', // TAXSTATUS
        unit_price: null,
        unit_price_inctax: null,
        row_price: null,
        quantity: null,
        total_cost: null,
        total_profit: null,
        total_unit_price: null,
        remarks: '',
        tax_rate: '10'
      }
    },
    prepareDetails (data) {
      // get details.total_cost
      data.total_cost = this.$util.calcTimes(data.row_price, data.quantity)

      // get details.total_unit_price
      if (this.$props.tax.taxIncluded) {
        data.total_unit_price = this.$util.calcTimes(data.unit_price_inctax, data.quantity)
      } else {
        data.total_unit_price = this.$util.calcTimes(data.unit_price, data.quantity)
      }

      // get details.total_profit
      data.total_profit = this.$util.calcMinus(data.total_unit_price, data.total_cost)

      return data
    },
    getToAddProduct () {
      let $this = this
      let ret = false
      this.tempDetails = []
      this.products.forEach((v) => {
        let price
        let priceInctax
        if ((!isNaN(v.quantity) && !isNaN(v.unit_price)) &&
        (v.quantity && v.unit_price)) {
          if ($this.$props.tax.taxIncluded) {
            price = $this.$util.getExcludeTax(v.unit_price, $this.$props.tax.taxRate)
            priceInctax = v.unit_price
          } else {
            price = v.unit_price
            priceInctax = $this.$util.getIncludeTax(v.unit_price, $this.$props.tax.taxRate)
          }
          this.tempDetails.push({
            product_id: v.product_id,
            jan_code: v.jan_code,
            type_number: v.type_number,
            tax_rate: $this.$props.tax.taxRate,
            taxclass_id: '1', // TAXSTATUS
            unit_price: price, // VAT INPUT @Modal
            unit_price_inctax: priceInctax,
            row_price: v.row_price,
            quantity: v.quantity,
            remarks: v.remarks,
            item_no: v.item_no
          })
          ret = true
        }
      })
      return ret
    },
    updateDetaitls () {
      if (this.getToAddProduct()) {
        this.tempDetails.forEach((v) => {
          let temp = this.prepareDetails(v)
          this.$props.details.push(temp)
        })
        this.products = []

        const btn = this.$refs.closeAddToModal
        btn.click()
      } else {
        this.$toastr.warning(this.translations('estimate.notice_enter_valid_number'))
      }
    }
  }
}
</script>
